import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Tabs from '../AdminTabs';
import { BREADCRUMB } from '../../../constants/admin/breadcrumb';
import { withBreadcrumb } from '../../../components/admin/hocs/BreadcrumbWrapper';
import * as selectors from '../../../selectors/admin/models/contracts';
import ContractEditor from '../../../components/admin/forms/contracts/ContractEditor';
import { onInput } from '../../../actions/admin/forms';
import {
    fetchVersions,
    switchVersion,
    removeContractFile,
    downloadUploadedContract
} from '../../../actions/admin/models/contracts';
import { currentTabSelector } from '../../../selectors/admin/tabs';
import MediaPartners from './MediaPartners';
import { currentUserSelector } from '../../../selectors/authentication';
import { ifPermission, PERMISSIONS, hasPermissions } from '../../../constants/authentication/permissions';
import ContractsForm from './ContractsForm';
import { editedSelector, submittingSelector } from '../../../selectors/admin/forms';
import { Prompt } from 'react-router';
import { ARE_YOU_SURE_TEXT } from '../../../constants/texts/errors';
import { CONTRACT_TYPES } from '../../../constants/settings';
import { MODELS } from '../../../constants/admin/settings';

class Details extends Component {
    state = {
        shouldBlockNavigation: false,
        isNew: true,
        type: new URLSearchParams(window.location.search).get('type')
    };

    componentDidMount() {
        if (this.props.location && this.props.location.pathname.includes('/contracts/new')) {
            this.props.onInput(MODELS.CONTRACT, 'editing', true);
            this.setState({ isNew: true });
        } else {
            this.setState({ isNew: false });
        }
    }

    componentDidUpdate() {
        if ((this.props.edited && !this.props.submitting) !== this.state.shouldBlockNavigation) {
            this.setState({ shouldBlockNavigation: this.props.edited && !this.props.submitting });
        }
    }

    render() {
        const contractId = this.props.match.params.contractId;
        return (
            <React.Fragment>
                <Prompt when={this.state.shouldBlockNavigation} message={ARE_YOU_SURE_TEXT} />
                <Tabs
                    disable={false}
                    inline={true}
                    labels={['General Details'].concat(
                        hasPermissions(this.props.user, PERMISSIONS.CONTRACTPARTNERS_VIEW) &&
                            (this.state.type || this.props.formData.type) !== CONTRACT_TYPES.PERFORMANCE
                            ? ['Media Partners']
                            : []
                    )}
                    content={[
                        <ContractsForm contractId={contractId} type={this.state.type} />,
                        ifPermission(
                            this.props.user,
                            PERMISSIONS.CONTRACTPARTNERS_VIEW,
                            (this.state.type || this.props.formData.type) !== CONTRACT_TYPES.PERFORMANCE ? (
                                <MediaPartners user={this.props.user} contractId={contractId} />
                            ) : null,
                            null
                        )
                    ]}
                />
                <ContractEditor
                    downloadVersion={this.props.downloadUploadedContract}
                    version={this.props.formData.version}
                    removeFile={this.props.removeContractFile}
                    fileData={this.props.formData.file ? `data:application/pdf;base64,${this.props.formData.file}` : ''}
                    transformTrigger={this.props.transformTrigger}
                    eventId={this.props.eventId}
                    eventName={this.props.eventName}
                    artistName={this.props.artistName}
                    feedback={this.props.feedback}
                    switchVersion={this.props.switchVersion}
                    contractId={contractId}
                    allVersions={this.props.allVersions}
                    selectedVersion={this.props.selectedVersion}
                    fetchVersions={this.props.fetchVersions}
                    templateData={this.props.templateData}
                    templateId={this.props.templateId}
                    readOnly={
                        this.props.isSigned || this.props.currentTab !== 0 || (contractId && !this.props.isLastVersion)
                    }
                    allPerformances={this.props.allPerformances}
                    versionUser={this.props.versionByUser}
                    data={this.props.editorData}
                    onInput={this.props.onInput}
                    editing={this.props.editing}
                    formData={this.props.formData}
                    activity={this.props.activity}
                    isNew={this.state.isNew}
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    transformTrigger: selectors.contractTransformTriggerSelector(state),
    eventId: selectors.contractEventIdSelector(state),
    formData: selectors.formDataSelector(state),
    templateData: selectors.templateDataSelector(state),
    user: currentUserSelector(state),
    activity: selectors.contractActivitySelector(state),
    allVersions: selectors.allVersionsOptionsSelector(state),
    versionByUser: selectors.versionUserSelector(state),
    selectedVersion: selectors.selectedVersionSelector(state),
    editing: selectors.editingSelector(state),
    editorData: selectors.editorDataSelector(state),
    feedback: selectors.feedbackSelector(state),
    templateId: selectors.editorTemplateSelector(state),
    currentTab: currentTabSelector(state),
    isLastVersion: selectors.isLastVersionSelector(state),
    isSigned: selectors.isSignedSelector(state),
    eventName: selectors.eventNameSelector(state),
    artistName: selectors.artistNameSelector(state),
    edited: editedSelector(state),
    submitting: submittingSelector(state),
    allPerformances: selectors.allPerformancesSelector(state)
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        { onInput, removeContractFile, fetchVersions, switchVersion, downloadUploadedContract },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withBreadcrumb(Details, () => [BREADCRUMB.CONTRACTS, BREADCRUMB.CONTRACTS_FORM]));
